// @flow
import React, { useContext } from 'react';

import { ButtonWithPopup } from '../../presentational/ButtonWithPopup';
import { EstimateContext } from '../../../contexts/EstimateContext';
import { ESTIMATE_COMMITTED_CAPACITY } from '../enums';
import { getDiscountBoundsCheckForEstimateCC } from '../utils';

export const DiscountOutOfBoundsWarningForEstimateCC = ({ dimensionRow, metricName }) => {
  const estimateData = useContext(EstimateContext);
  const discountValue = dimensionRow[ESTIMATE_COMMITTED_CAPACITY.DISCOUNT_BACKEND_FIELD_NAME];

  const { minDiscount, maxDiscount, isOutOfBounds } = getDiscountBoundsCheckForEstimateCC(
    metricName,
    discountValue,
    estimateData,
    dimensionRow
  );

  if (!isOutOfBounds || discountValue == null) {
    return null;
  }

  return (
    <ButtonWithPopup
      circular={true}
      color="orange"
      icon="warning sign"
      popupContent={`Discount is outside the allowed range (${minDiscount}% - ${maxDiscount}%)`}
      size="small"
      text={null} // text should be null so that Semantic treats it as a simple circular button
    />
  );
};
